import React, { useEffect, useState } from 'react';
import { Modal, Input, Select, Button, Form, message } from 'antd';
import styles from './s.module.less';
import StateSelect from 'components/form/StateSelect';
import { createClosedFunnel } from 'api/operation/closedFunnel';

const typeOptions = [
    { label: 'Condition', value: 'CONDITION' },
    // 可扩展
];

interface AddModalProps {
    statesOptions: { label: string; value: string }[];
    conditionOptions: { label: string; value: string }[];
    open: boolean;
    onCancel: () => void;
    onAdd: (id: number) => void;
}

const AddModal: React.FC<AddModalProps> = ({ open, onCancel, onAdd, conditionOptions, statesOptions }) => {
    const [form] = Form.useForm();
    const [name, setName] = useState('');
    const typeWatched = Form.useWatch('type', form);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        form.setFieldValue('states', statesOptions.map((item) => item.value));
    }, [form, statesOptions]);

    const handleSubmit = async () => {
        form.validateFields().then(async (values) => {
            setLoading(true);
            try {
                const res = await createClosedFunnel({
                    ...values,
                    states: values.states.join(','),
                    typeValues: values.typeValues.join(','),
                });
                if (res && !res.error) {
                    const id = res.data.data;
                    onAdd(id);
                    form.resetFields();
                } else {
                    message.error(res?.error);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        });
    };

    return (
        <Modal
            open={open}
            width={680}
            title="Add a new funnel"
            onCancel={onCancel}
            footer={null}
            centered
            className={styles.addModal}
            destroyOnClose
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={onAdd}
            >
                <Form.Item
                    label={<span>Funnel name <span className={styles.required}>*</span></span>}
                    name="name"
                    rules={[{ required: true, message: 'Please input funnel name' }]}
                >
                    <Input
                        maxLength={70}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder=""
                        suffix={<span className={styles.counter}>{name.length}/70</span>}
                    />
                </Form.Item>
                <Form.Item
                    label={<span>Applicable states</span>}
                    name="states"
                    rules={[{ required: true, message: 'Please select states' }]}
                >
                    <StateSelect allowClear maxTagCount="responsive" mode="multiple" isShowValue />
                </Form.Item>
                <Form.Item
                    label={<span>Type</span>}
                    name="type"
                    rules={[{ required: true, message: 'Please select type' }]}
                >
                    <Select options={typeOptions} />
                </Form.Item>
                {
                    typeWatched && (
                        <Form.Item
                            label={<span>Condition</span>}
                            name="typeValues"
                            rules={[{ required: true, message: 'Please select condition' }]}
                        >
                            <Select mode="multiple" options={conditionOptions} />
                        </Form.Item>
                    )
                }
                <div className={styles.footerBtns}>
                    <Button onClick={onCancel} className={styles.cancelBtn}>Cancel</Button>
                    <Button type="primary" className={styles.addBtn} onClick={handleSubmit} loading={loading}>Add</Button>
                </div>
            </Form>
        </Modal>
    );
};

export default AddModal;
